import { useIntl } from 'react-intl';

import type { AuthFailureCode } from '../lib/auth-client.ts';
import { Alert, AlertDescription } from './ui/alert.tsx';
import { Button } from './ui/button.tsx';

export function mergePromptVisible(
  hasToken: boolean,
  hasSession: boolean,
  actionError: AuthFailureCode | null,
) {
  return (
    hasToken &&
    hasSession &&
    (actionError === 'conflict' || actionError === 'merge-conflict')
  );
}

export function TelegramMergePrompt({
  actionError,
  isActing,
  onConfirm,
  onDecline,
}: {
  actionError: 'conflict' | 'merge-conflict';
  isActing: boolean;
  onConfirm: () => void;
  onDecline: () => void;
}) {
  const intl = useIntl();
  return (
    <Alert className="mt-4 grid gap-3">
      <h2>{intl.formatMessage({ id: 'web.auth.mergeTitle' })}</h2>
      <p>{intl.formatMessage({ id: 'web.auth.mergeDescription' })}</p>
      {actionError === 'merge-conflict' ? (
        <AlertDescription className="text-destructive">
          {intl.formatMessage({ id: 'web.auth.mergeConflict' })}
        </AlertDescription>
      ) : null}
      <div className="flex flex-wrap gap-3">
        <Button
          className="min-h-11 font-semibold"
          variant="default"
          disabled={isActing || actionError === 'merge-conflict'}
          onClick={onConfirm}
          type="button"
        >
          {intl.formatMessage({ id: 'web.auth.mergeConfirm' })}
        </Button>
        <Button
          className="min-h-11 font-semibold"
          variant="secondary"
          disabled={isActing}
          onClick={onDecline}
          type="button"
        >
          {intl.formatMessage({ id: 'web.auth.mergeDecline' })}
        </Button>
      </div>
    </Alert>
  );
}
